import { makeVar } from '@apollo/client'

export const emptySearchState = {
  input: '',
  search: '',
  selectionIndex: -1,
}

export const searchState = makeVar({
  ...emptySearchState,
  search: new URLSearchParams(window.location.search).get('keyword') || '',
})
